export default __webpack_public_path__ + "static/media/terms-of-service-consent-en-1.eb14c6dd.jpg";